import React, { Component } from 'react';
import moment from 'moment';

import CamdetectCamerasSettingForm from './CamdetectCamerasSettingForm';
import CamdetectCamerasPasswordForm from './CamdetectCamerasPasswordForm';

import { defaultSorter, dateSorter } from './Helpers';
import CamdetectCamerasModel from './CamdetectCamerasModel';
import CamdetectLazyImage from './CamdetectLazyImage';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Statistic, Popconfirm, Divider, message, Card, Typography } from 'antd';
import { values } from 'lodash';

class CamdetectCamerasTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    camdetectCameraSettingsFormData: null,
    camdetectCameraPasswordFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    const calculateUptimeString = () => {
      var uptimeString = "";
      if (record.uptime !== 0) {
        const duration = moment.duration(record.uptime, "seconds");
        if (duration.days() !== 0) {
          uptimeString += duration.days() + ' d ';
        }
        if (duration.hours() !== 0) {
          uptimeString += duration.hours() + ' h ';
        }
        if (duration.minutes() !== 0) {
          uptimeString += duration.minutes() + ' min ';
        }
        if (duration.seconds() !== 0) {
          uptimeString += duration.seconds() + ' s';
        }
      } else {
        uptimeString = "0 s";
      }
      return uptimeString;
    };
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={3}>
            <Card title="Trvalé napájení">
              {record.grid ? "ANO" : "NE"}
            </Card>
          </Col>
          <Col span={2}>
            <Card title="Napětí [V]">
              {record.voltage ? record.voltage.toFixed(2) : "-"}
            </Card>
          </Col>
          <Col span={3}>
            <Card title="Teplota [°C]">
              {record.temperature ? record.temperature.toFixed(2) : "-"}
            </Card>
          </Col>
          <Col span={3}>
            <Card title="Interval zpráv [min]">
              {record.messageInterval ? record.messageInterval : "-"}
            </Card>
          </Col>
          <Col span={5}>
            <Card title="Doba provozu">
              {calculateUptimeString()}
            </Card>
          </Col>
          <Col span={20}>
            <Card title="Popis">
              {record.description ? record.description : " - "}
            </Card>
          </Col>
        </Row>
        <Row>
          <Col span={4}>
            <Card title="Čas technologických dat">
              {record.techDataTimestamp ? moment(record.techDataTimestamp).format('L LTS') : "-"}
            </Card>
          </Col>
          {UserModel.isInRoles(['ADMIN', 'CAMDETECT_CAMERAS_IMAGE_READ']) &&
            <Col span={24}>
              <Card title="Poslední detekce">
                {/* this will unmount after loading because record.lastImage is here always the same */}
                {!this.props.loading && <CamdetectLazyImage imageString={record.lastImage} />}
              </Card>
            </Col>
          }
        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 270,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName)
    }, {
      title: 'Název kamery',
      dataIndex: 'cameraName',
      key: 'cameraName',
      width: 100,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.cameraName, b.cameraName)
    }, {
      title: 'Obsazeno Parking',
      dataIndex: 'occ',
      key: 'occ',
      width: 75,
      sorter: (a, b) => defaultSorter(a.occ, b.occ)
    }, {
      title: 'Obsazeno Invalidé',
      dataIndex: 'disabledOcc',
      key: 'disabledOcc',
      width: 75,
      sorter: (a, b) => dateSorter(a.disabledOcc, b.disabledOcc),
    }, {
      title: 'Počítat invalidy do TotalOcc parkoviště',
      dataIndex: 'countDisabledToTotal',
      key: 'countDisabledToTotal',
      width: 75,
      render: (text, record) => {
        if (record.countDisabledToTotal) {
          return ('ANO');
        } else {
          return ('NE');
        }
      },
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'lastChange',
      key: 'lastChange',
      width: 185,
      sorter: (a, b) => dateSorter(a.lastChange, b.lastChange),
      render: (text, record) => {
        if (!record.lastChange) {
          return "-"
        } else {

          if (moment(record.lastChange) <= moment().subtract(120, "minutes")) {
            return (
              <Badge
                status="error"
                text={moment(text).format('L LTS')}
                title="Poslední komunikace před více než 2 hodinami" />
            );
          } else if (moment(record.lastChange) <= moment().subtract(60, "minutes")) {
            return (
              <Badge
                status="warning"
                text={moment(text).format('L LTS')}
                title="Poslední komunikace před více než 60 minutami" />
            );
          } else {
            return (
              <Badge
                status="success"
                text={moment(text).format('L LTS')}
                title="Vpořádku" />
            );
          }
        }
      }
    }, {
      title: 'Upozornění',
      dataIndex: 'reportsEnabled',
      key: 'reportsEnabled',
      width: 130,
      filters: [{
        text: 'ZAPNUTO',
        value: true,
      }, {
        text: 'VYPNUTO',
        value: false,
      }],
      filteredValue: filteredInfo.reportsEnabled || null,
      onFilter: (value, record) => { return ((record.reportsEnabled === value)) ? true : false },
      render: (text, record) => {
        if (record.reportsEnabled === true) {
          return (
            <Badge
              status="success"
              text="ZAPNUTO" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="VYPNUTO"
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'CAMDETECT_CAMERAS_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  camdetectCameraSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <a onClick={(e) => {
                this.setState({
                  camdetectCameraPasswordFormData: record
                });
              }}>Změna hesla</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          expandedRowRender={this.expandedRowRender.bind(this)}
          style={{ border: '0px' }} />
        <CamdetectCamerasSettingForm
          type="modal"
          modalVisible={this.state.camdetectCameraSettingsFormData === null ? false : true}
          initialValues={this.state.camdetectCameraSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ camdetectCameraSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            CamdetectCamerasModel.patch(this.state.camdetectCameraSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  camdetectCameraSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
        <CamdetectCamerasPasswordForm
          type="modal"
          modalVisible={this.state.camdetectCameraPasswordFormData === null ? false : true}
          initialValues={this.state.camdetectCameraPasswordFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ camdetectCameraPasswordFormData: null });
          }}
          onSuccess={(form, values) => {
            CamdetectCamerasModel.patch(this.state.camdetectCameraPasswordFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  camdetectCameraPasswordFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default CamdetectCamerasTable;


// WEBPACK FOOTER //
// ./src/components/CamdetectCamerasTable.js